// Separators (space/hyphen) only at the very start or end of the string.
const LEADING_OR_TRAILING_PLATE_SEPARATOR_REGEX = /^[ -]+|[ -]+$/g;

/** Removes leading/trailing separators from a plate, keeping internal ones: "  M-AB 1234-" -> "M-AB 1234". */
export const trimPlateSeparators = (value: string) =>
  value.replace(LEADING_OR_TRAILING_PLATE_SEPARATOR_REGEX, '');
